import React from 'react';
import './css/PlatformHeader.css';

/** One AccountManagement-style mobile header for authenticated pages.
 * Page-specific titles, languages, and navigation are supplied as props.
 * Browser owns its search toolbar; Register and Welcome do not use this component.
 */
export default function PlatformHeader({ title, language = 'english', onHome, onMenu, className = '' }) {
  return (
    <header className={`tbp-shared-page-header ${className}`.trim()}>
      <button type="button" className="tbp-shared-page-header__brand"
        aria-label={language === 'spanish' ? 'Volver al inicio' : 'Back to Home'} onClick={onHome}>
        <img src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png" alt="The Blender Platform" />
      </button>
      <div className="tbp-shared-page-header__heading">
        <span className="tbp-shared-page-header__eyebrow">THE BLENDER PLATFORM</span>
        <h1 className="tbp-shared-page-header__title">{title}</h1>
      </div>
      <button type="button" className="tbp-shared-page-header__menu"
        aria-label={language === 'spanish' ? 'Abrir menú' : 'Open menu'} onClick={onMenu}>
        <i className="bars icon" aria-hidden="true" />
      </button>
    </header>
  );
}
